import { Loader2Icon } from 'lucide-react'

import { cn } from '@/lib/utils'

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role="status" className="inline-flex items-center gap-2">
      <Loader2Icon className={cn('size-4 animate-spin', className)} aria-hidden="true" />
      <span className="sr-only">{label ?? 'Loading'}</span>
    </span>
  )
}
